import React from 'react';
import styles from './PostFlowIndicator.module.scss';

const PostFlowIndicator = ({}) => {
  return (
    <div>
      <div
        className="m hidden-sm hidden-md hidden-lg hidden-xl"
        style={{ whiteSpace: 'nowrap' }}
      >
        <p className="fs-15 pt- lato-bold">How it works:</p>
        <div className="mb" style={{ display: 'flex' }}>
          <div style={{ display: 'inline-block' }} className={styles.steps}>
            1
          </div>
          <div
            style={{ display: 'inline-block', margin: '5px 10px' }}
            className="mb fs-15"
          >
            Describe project <span className="aside-text">(1-15 minutes)</span>
          </div>
        </div>
        <div className="mb" style={{ display: 'flex' }}>
          <div style={{ display: 'inline-block' }} className={styles.steps}>
            2
          </div>
          <div
            style={{ display: 'inline-block', margin: '5px 10px' }}
            className="mb fs-15"
          >
            Receive pitches <span className="aside-text">(in 24 hours)</span>
          </div>
        </div>
        <div className="mb" style={{ display: 'flex' }}>
          <div style={{ display: 'inline-block' }} className={styles.steps}>
            3
          </div>
          <div
            style={{ display: 'inline-block', margin: '5px 10px' }}
            className="mb fs-15"
          >
            Hire securely <span className="aside-text">(pay on Twine)</span>
          </div>
        </div>
        <hr />
      </div>
      <div
        className="hidden-xs text-center mt++ mb++"
        style={{ whiteSpace: 'nowrap' }}
      >
        <div className={styles.steps}>1</div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.steps}>2</div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.greyDot}></div>
        <div className={styles.steps}>3</div>
        <br />
        <div className={`fs-15 ${styles.stepText}`}>
          Describe project <br />
          <span className="aside-text">(1-15 minutes)</span>
        </div>
        <div className={`fs-15 ${styles.stepText}`}>
          Receive pitches <br />
          <span className="aside-text">(in 24 hours)</span>
        </div>
        <div className={`fs-15 ${styles.stepText}`}>
          Hire securely <br />
          <span className="aside-text">(pay on Twine)</span>
        </div>
      </div>
    </div>
  );
};

export default PostFlowIndicator;
